import { asArray } from './asArray';

const ASSIGN_MENU_FLAGS: Record<string, string> = {
  '7': 'Tag',
  '6': 'MP',
  '12': 'DM',
  '8': 'SP',
  '13': 'loungeland',
  '14': 'club333',
  '15': 'editor',
};

/** Rights-binding only — not an auth key. Must never be token/user_id/user_name/email/access. */
export const ASSIGN_MENU_USER_KEY = 'mw_assign_menu_user';

export function readStoredAssignMenuUserId() {
  const storedUserId = localStorage.getItem('user_id');
  if (
    storedUserId == null ||
    storedUserId === '' ||
    storedUserId === 'null' ||
    storedUserId === 'undefined'
  ) {
    return '';
  }
  return storedUserId;
}

function stampAssignMenuUser(userId: string) {
  localStorage.setItem(ASSIGN_MENU_USER_KEY, userId);
}

/** Persist admin-menu rights for the current user_id and always return an array. */
export function applyAssignMenuFlags(menu: unknown) {
  const items = asArray(menu);
  const ids = new Set(items.map((item) => String(item?.rights_id ?? '')));
  Object.entries(ASSIGN_MENU_FLAGS).forEach(([id, key]) => {
    localStorage.setItem(key, ids.has(id) ? 'true' : '');
  });
  stampAssignMenuUser(readStoredAssignMenuUserId());
  return items;
}

/**
 * Drop leftover rights when localStorage.user_id no longer matches the member
 * those flags were applied for (WebView user-switch without logout).
 */
export function syncAssignMenuFlagsToCurrentUser() {
  const userId = readStoredAssignMenuUserId();
  const owner = localStorage.getItem(ASSIGN_MENU_USER_KEY) || '';
  if (owner !== userId) {
    applyAssignMenuFlags([]);
  }
  return userId;
}

/** rights_id 15 — Advanced Composer. Independent of Club 333 (14) and admin. */
export function hasAdvancedComposerPermission() {
  const userId = readStoredAssignMenuUserId();
  if (!userId) return false;
  const owner = localStorage.getItem(ASSIGN_MENU_USER_KEY) || '';
  if (owner !== userId) return false;
  return localStorage.getItem('editor') === 'true';
}
